export default function DisclosureRoute() {
	return <p>Disclosure</p>
}
